import React from 'react';
import Intl from '@fx-ui/intl';
import { IconFont } from '~/components';
import classNames from 'classnames';
import { isMobileUA } from '~/utils';

interface AccountBackButtonProps {
    name?: string;
    onClick: () => void;
}

const AccountBackButton: React.FC<AccountBackButtonProps> = (props) => {
    const { name, onClick } = props;

    return (
        <div
            className={classNames('fx-account-back-button', {
                'is-mobile': isMobileUA()
            })}
            onClick={onClick}
        >
            <IconFont type="angle-left" className="icon" />
            {name ?? Intl.get('account.signin.account')}
        </div>
    );
};

export default AccountBackButton;
